import { connect } from 'react-redux';
import LoggedLayout from './LoggedLayout'

export default connect(
  state => ({
    headerTitle: state.layout.title
  })
)(LoggedLayout);




// WEBPACK FOOTER //
// ./src/components/LoggedLayout/index.jsx